import { render, staticRenderFns } from "./links.vue?vue&type=template&id=8a4de1c4"
import script from "./links.vue?vue&type=script&lang=tsx"
export * from "./links.vue?vue&type=script&lang=tsx"
import style0 from "./links.vue?vue&type=style&index=0&id=8a4de1c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports